import React from 'react';

import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';
import OrganizationProfile from '@views/Organization/Setting/Profile';

export default function OrganizationProfilePage(
  props: PagePropsWithBreadcrumbs
) {
  return (
    <OrgSettingLayout pageProps={props}>
      {({ account, loading }) => (
        <OrganizationProfile account={account} loading={loading} />
      )}
    </OrgSettingLayout>
  );
}
